import { Layout } from "antd";
import HeaderConek from "../Header/HeaderConek";
import { neutral } from "../../theme/tokens";

const { Header } = Layout;

/**
 * Thanh trên cùng — khung tham khảo CRM: nền trắng, viền dưới mảnh, cao 64px, sticky.
 * Nội dung (logo, thông báo, user menu, toggle theme) giữ nguyên ở HeaderConek.
 */
export default function Topbar() {
  return (
    <Header
      style={{
        height: 64,
        lineHeight: "64px",
        padding: "0 20px",
        backgroundColor: neutral[0],
        borderBottom: `1px solid ${neutral[200]}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      <HeaderConek />
    </Header>
  );
}
